// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"732":"b9583282","977":"d494e6ad"}[chunkId] + ".chunk.js");